module.exports = __webpack_public_path__ + "img/plus.41cc049f.svg";